import { render, staticRenderFns } from "./category-menu.vue?vue&type=template&id=09bebf67&lang=pug&"
import script from "./category-menu.vue?vue&type=script&lang=js&"
export * from "./category-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports